import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 13v-1h6v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 18h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 12v6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileType2";
const FileType2 = memo(themed(Icon));
export {
  FileType2
};
//# sourceMappingURL=file-type-2.js.map
